/* Add history to real term menus only after public availability is confirmed. */
(function () {
  'use strict';
  var api = window.ARTICLE_REVISIONS;
  var known = new Map(), pending = new Set(), timer, scanning = false;
  function refresh() {
    clearTimeout(timer); timer = setTimeout(scan, 100);
  }
  async function scan() {
    if (scanning) { refresh(); return; }
    scanning = true;
    var now = Date.now();
    known.forEach(function (value, key) { if (value.until <= now) known.delete(key); });
    var articles = Array.from(document.querySelectorAll('#results-container .opredelenie[data-guid]'));
    var missing = [];
    articles.forEach(function (article) {
      var guid = article.getAttribute('data-guid');
      if (!/^[A-Za-z][A-Za-z0-9_]{0,79}:[1-9][0-9]{0,9}$/.test(guid)) return;
      var cached = known.get(guid);
      if (cached && cached.until > Date.now()) {
        var menu = article.querySelector('.zaglavie-more-menu');
        var existing = article.querySelector('.revision-history-btn');
        if (cached.available && menu && !existing) {
          var button = document.createElement('button');
          button.type = 'button'; button.className = 'revision-history-btn';
          button.setAttribute('role', 'menuitem');
          var icon = document.createElement('i'); icon.className = 'bi bi-clock-history';
          icon.setAttribute('aria-hidden', 'true'); button.appendChild(icon);
          var label = document.createElement('span'); label.textContent = api.text('title');
          button.appendChild(label); menu.appendChild(button);
        } else if (!cached.available && existing) existing.remove();
        if (existing && existing.querySelector('span').textContent !== api.text('title')) {
          existing.querySelector('span').textContent = api.text('title');
        }
      } else if (!pending.has(guid) && missing.indexOf(guid) < 0) missing.push(guid);
    });
    for (var offset = 0; offset < missing.length; offset += 100) {
      var batch = missing.slice(offset, offset + 100); batch.forEach(function (g) { pending.add(g); });
      try {
        var data = await api.request({ guids: batch.join(',') });
        var available = new Set(data.available);
        batch.forEach(function (g) { known.set(g, { available: available.has(g), until: Date.now() + 60000 }); });
      } catch (e) {
        batch.forEach(function (g) { known.set(g, { available: false, until: Date.now() + 5000 }); });
      } finally { batch.forEach(function (g) { pending.delete(g); }); }
    }
    // Keep only a bounded session cache; old searches are cheap to re-check.
    var visible = new Set(articles.map(function (a) { return a.getAttribute('data-guid'); }));
    known.forEach(function (value, key) {
      if (known.size > 1000 && !visible.has(key)) known.delete(key);
    });
    scanning = false;
    if (missing.length) refresh();
  }
  function init() {
    var root = document.getElementById('results-container');
    if (!root) return;
    new MutationObserver(function (changes) {
      changes.forEach(function (change) {
        var descr = change.target.nodeType === 1 && change.target.closest('.descr');
        var article = descr && descr.closest('.opredelenie[data-guid]');
        if (article) known.delete(article.getAttribute('data-guid'));
      });
      refresh();
    }).observe(root, { childList: true, subtree: true });
    refresh();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.revision-history-btn');
    if (button) {
      event.preventDefault(); event.stopPropagation();
      if (window.SEARCH_TERM_MENU) window.SEARCH_TERM_MENU.closeAll();
      api.open(button.closest('.opredelenie'), button);
    } else if (event.target.closest && event.target.closest('.zaglavie')) refresh();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
